import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MobileBreakpointService } from 'src/app/services/mobile-breakpoint.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { RouterService } from '../../services/router.service';

export interface NavListItem {
  linkTitle: string;
  link: string;
  icon: string;
  subtitle?: string;
  hidden?: boolean;
}

@Component({
  selector: 'app-nav-list',
  templateUrl: './nav-list.component.html',
  styleUrls: ['./nav-list.component.scss'],
})
export class NavListComponent implements OnInit, OnDestroy {
  navlistItems: NavListItem[] = [];
  public isCollapsed: boolean = this.sidenavService.isCollapsed();
  public isMobile: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private routerService: RouterService,
    public sidenavService: SidenavService,
    private mobileBreakpointService: MobileBreakpointService
  ) {
    this.isMobile = this.mobileBreakpointService.isMobile();
    this.handleGetNavlistItems();
  }

  ngOnInit(): void {
    this.checkIfSidenavIsCollapsed();
    this.checkIfIsMobile();
    this.handleGetNavlistItems();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private handleGetNavlistItems(): void {
    this.routerService.listItems$
      .pipe(takeUntil(this.destroy$))
      .subscribe((listItems) => {
        this.navlistItems = listItems;
      });
  }

  private checkIfSidenavIsCollapsed(): void {
    this.sidenavService.collapsedSidenav$
      .pipe(takeUntil(this.destroy$))
      .subscribe((collapsed) => {
        this.isCollapsed = collapsed;
      });
  }

  private checkIfIsMobile(): void {
    this.mobileBreakpointService.isMobile$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isMobile) => {
        this.isMobile = isMobile;
      });
  }

  onClickNavItem(): void {
    if (this.isCollapsed && this.isMobile) {
      this.sidenavService.close();
    }
  }

  trackByLink(index: number, item: NavListItem): string {
    return item.link;
  }
}
